import { render, staticRenderFns } from "./LProjectMemoryObject.vue?vue&type=template&id=71e88e98&scoped=true&"
import script from "./LProjectMemoryObject.vue?vue&type=script&lang=js&"
export * from "./LProjectMemoryObject.vue?vue&type=script&lang=js&"
import style0 from "./LProjectMemoryObject.vue?vue&type=style&index=0&id=71e88e98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e88e98",
  null
  
)

export default component.exports